import { ChartType, getHiddenTableFields, } from './savedCharts';
export const getPivotConfig = (savedChart) => savedChart.chartConfig.type === ChartType.TABLE &&
    savedChart.pivotConfig !== undefined
    ? {
        pivotDimensions: savedChart.pivotConfig.columns,
        metricsAsRows: savedChart.chartConfig.config?.metricsAsRows ?? false,
        hiddenMetricFieldIds: getHiddenTableFields(savedChart.chartConfig),
        columnOrder: savedChart.tableConfig.columnOrder,
        rowTotals: savedChart.chartConfig.config?.showRowCalculation ?? false,
    }
    : undefined;
//# sourceMappingURL=pivot.js.map